import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: 'fa-user-tie',
      title: 'Expert Team',
      description: 'Qualified CA, CS, and legal professionals with years of experience'
    },
    {
      icon: 'fa-clock',
      title: 'Quick Turnaround',
      description: 'Fast processing with guaranteed delivery timelines'
    },
    {
      icon: 'fa-shield-alt',
      title: '100% Secure',
      description: 'Your data is completely safe and confidential with us'
    },
    {
      icon: 'fa-rupee-sign',
      title: 'Affordable Pricing',
      description: 'Transparent and competitive pricing with no hidden charges'
    },
    {
      icon: 'fa-headset',
      title: '24/7 Support',
      description: 'Round-the-clock customer support for all your queries'
    },
    {
      icon: 'fa-check-double',
      title: '100% Satisfaction',
      description: 'Money-back guarantee if you are not satisfied'
    }
  ];

  const stats = [
    { number: '10,000+', label: 'Happy Clients' },
    { number: '15+', label: 'Years Experience' },
    { number: '50+', label: 'Expert Team' },
    { number: '98%', label: 'Success Rate' }
  ];

  return (
    <section id="about" className="why-choose-us">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose NV Consulting?</h2>
          <p>Your success is our priority</p>
        </div>
        
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-icon">
                <i className={`fas ${reason.icon}`}></i>
              </div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="stats-section">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
